import { Button, LoadingSkeleton } from "@narmi/design_system";
import { RouteObject, useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { $staffApi } from "../../api";
import { PageContainer } from "../../components/PageContainer";
import { ValidatedRoutes } from "../../components/PermissionedRoutes";
import { TopBar } from "../../components/TopBar";
import { PromptIndex } from "./PromptIndex";

export const GUIDES_ROUTES: RouteObject[] = [
  {
    element: (
      <ValidatedRoutes
        validate={({ permissions }) => permissions.includes("indigo.view_promptgroup")}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          return {
            Component() {
              const navigate = useNavigate();

              return (
                <>
                  <TopBar.Compact>
                    <TopBar.Breadcrumb>Guides</TopBar.Breadcrumb>
                    <TopBar.Spacer />
                    <Button
                      label="New guide"
                      variant="primary"
                      size="xs"
                      onClick={() => {
                        const uuid = uuidv4();
                        navigate(`/guides/${uuid}`);
                      }}
                    />
                  </TopBar.Compact>
                  <PageContainer>
                    <PromptIndex />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
      {
        path: ":promptGroupId/:section?",
        async lazy() {
          const { CreateForm } = await import("./CreateForm");

          return {
            Component() {
              // this will likely get picked up by the react query cache
              const { data, isLoading } = $staffApi.useQuery("get", "/api/prompt_groups/");
              const params = useParams<{
                promptGroupId: string;
                section?: string;
              }>();
              const navigate = useNavigate();

              return (
                <LoadingSkeleton isLoading={isLoading}>
                  <TopBar
                    title="New guide"
                    backIconOnClick={
                      data?.results && data?.results.length > 0
                        ? () => navigate("/guides")
                        : undefined
                    }
                  />
                  <PageContainer>
                    <CreateForm
                      promptGroupId={params.promptGroupId!}
                      section={params.section ?? null}
                    />
                  </PageContainer>
                </LoadingSkeleton>
              );
            },
          };
        },
      },
    ],
  },
];
